import * as Yup from "yup"; // Import Yup
import { validatePasswordPolicy } from "../../lib/utils/validatePasswordPolicy";
// {
//   password,
//   confirmPassword
// }

const updatePasswordValidationSchema = (passwordPolicy) => Yup.object().shape({
    currentPassword: Yup.string().required("Current Password is required"),
    password: Yup.string()
      .required("New Password is required")
      .test(
        "password-policy",
        "Invalid Password",
        function (value) {
          const errorMessage = validatePasswordPolicy({password: value, passwordPolicy: passwordPolicy});
          return errorMessage ? this.createError({ message: errorMessage }) : true;
        }
      )
      .notOneOf([Yup.ref("currentPassword")], "New password cannot be the same as the current password"), // Regex for password
    confirmPassword: Yup.string()
      .required("Confirm Password is required")
      .oneOf([Yup.ref("password")], "New Password and Confirm Password must match!")
});

const setPasswordValidationSchema = (passwordPolicy) => Yup.object().shape({
  password: Yup.string()
    .required("New Password is required")
    .test(
      "password-policy",
      "Invalid Password",
      function (value) {
        const errorMessage = validatePasswordPolicy({password: value, passwordPolicy: passwordPolicy});
        return errorMessage ? this.createError({ message: errorMessage }) : true;
      }
    ),
  confirmPassword: Yup.string()
    .required("Confirm Password is required")
    .oneOf([Yup.ref("password")], "New Password and Confirm Password must match!")
});

const myProfileValidationSchema = Yup.object().shape({
  userFirstName: Yup.string(),
  userLastName: Yup.string(),
  userNickName: Yup.string().required("Nickname is required"),
  dob: Yup.string()
  .nullable()
  .test(
    "is-before-today",
    "Date of Birth cannot be in the future",
    (value) => {
      if (!value) return true; // Allow empty or null value
      return new Date(value) <= new Date(); // Validate only if the value exists
    }
  ),
  gender: Yup.string(),

});

export  {updatePasswordValidationSchema, setPasswordValidationSchema, myProfileValidationSchema};
